function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#57A6DD;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#221F20;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFCA05;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#00A4DF;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#EE4123;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st7{fill:#305692;}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#F7A600;}\n\t.st9{fill:#F2F2F2;}\n\t.st10{fill:#FF5F00;}\n\t.st11{fill:#EB001B;}\n\t.st12{fill:#F79E1B;}\n\t.st13{fill:#BC2B2B;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M50.99,40H7.01C3.15,40,0,36.85,0,32.99V7.01C0,3.15,3.15,0,7.01,0h43.98C54.85,0,58,3.15,58,7.01v25.98 C58,36.85,54.85,40,50.99,40z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "22.97,26.06 25.04,13.96 28.35,13.96 26.28,26.06 22.97,26.06  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M38.25,14.26c-0.65-0.23-1.69-0.5-2.96-0.5c-3.27,0-5.56,1.64-5.58,3.99c-0.02,1.74,1.64,2.7,2.89,3.29 c1.29,0.6,1.72,0.97,1.7,1.5c0,0.82-1.02,1.19-1.97,1.19c-1.32,0-2.02-0.18-3.11-0.63l-0.43-0.2l-0.45,2.7 c0.77,0.35,2.19,0.63,3.67,0.65c3.47,0,5.71-1.62,5.74-4.14c0.02-1.37-0.87-2.42-2.77-3.29c-1.15-0.55-1.85-0.92-1.85-1.49 c0-0.52,0.6-1.05,1.89-1.05c1.09-0.02,1.87,0.22,2.47,0.47l0.3,0.13L38.25,14.26L38.25,14.26z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M46.71,13.97h-2.55c-0.78,0-1.39,0.22-1.74,1l-4.89,11.1h3.46c0,0,0.57-1.5,0.7-1.82c0.38,0,3.74,0,4.22,0 c0.1,0.42,0.4,1.82,0.4,1.82h3.06L46.71,13.97L46.71,13.97z M42.64,21.77c0.27-0.68,1.32-3.37,1.32-3.37 c-0.03,0.03,0.27-0.7,0.43-1.15l0.22,1.04c0,0,0.63,2.89,0.77,3.49H42.64L42.64,21.77z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M20.22,13.97l-3.24,8.25l-0.33-1.67c-0.6-1.94-2.49-4.02-4.57-5.08l2.96,10.58h3.49l5.19-12.09H20.22 L20.22,13.97z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M13.99,13.96H8.67l-0.03,0.27c4.12,1,6.88,3.42,8.01,6.33l-1.17-5.56C15.28,14.22,14.71,13.99,13.99,13.96 L13.99,13.96z"
})));

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58 40",
    style: {
      enableBackground: "new 0 0 58 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.1344ade3.svg";
export { ForwardRef as ReactComponent };